import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusBillingDayRowFieldsFragment = { readonly __typename?: 'EpocusBillingDayRow', readonly encounterId: string, readonly examId: string, readonly billingId?: string | null, readonly patientName?: string | null, readonly identifiers: ReadonlyArray<string>, readonly examType: string, readonly examLabel: string, readonly accessionNumber?: string | null, readonly cptCode?: string | null, readonly modifier?: string | null, readonly device?: string | null, readonly billingStatus?: Types.EpocusBillingState | null, readonly missingItems: ReadonlyArray<Types.EpocusBillingMissingItem>, readonly amendedAfterExportAt?: string | null, readonly holdReason?: Types.EpocusBillingHoldReason | null, readonly alreadySent: boolean, readonly renderingProvider: { readonly __typename?: 'EpocusRenderingProvider', readonly name?: string | null, readonly npi?: string | null }, readonly feeEstimate?: { readonly __typename?: 'EpocusStudyFeeEstimate', readonly amountCents?: number | null, readonly needsProgramPostalCode: boolean, readonly unestimatedLineCount: number } | null };

export type EpocusBillingDayQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
  serviceDate: Types.Scalars['DateTime'];
}>;


export type EpocusBillingDayQuery = { readonly __typename?: 'Query', readonly epocusBillingDay: { readonly __typename?: 'EpocusBillingDay', readonly programId: string, readonly serviceDate: string, readonly billable: ReadonlyArray<{ readonly __typename?: 'EpocusBillingDayRow', readonly encounterId: string, readonly examId: string, readonly billingId?: string | null, readonly patientName?: string | null, readonly identifiers: ReadonlyArray<string>, readonly examType: string, readonly examLabel: string, readonly accessionNumber?: string | null, readonly cptCode?: string | null, readonly modifier?: string | null, readonly device?: string | null, readonly billingStatus?: Types.EpocusBillingState | null, readonly missingItems: ReadonlyArray<Types.EpocusBillingMissingItem>, readonly amendedAfterExportAt?: string | null, readonly holdReason?: Types.EpocusBillingHoldReason | null, readonly alreadySent: boolean, readonly renderingProvider: { readonly __typename?: 'EpocusRenderingProvider', readonly name?: string | null, readonly npi?: string | null }, readonly feeEstimate?: { readonly __typename?: 'EpocusStudyFeeEstimate', readonly amountCents?: number | null, readonly needsProgramPostalCode: boolean, readonly unestimatedLineCount: number } | null }>, readonly heldBack: ReadonlyArray<{ readonly __typename?: 'EpocusBillingDayRow', readonly encounterId: string, readonly examId: string, readonly billingId?: string | null, readonly patientName?: string | null, readonly identifiers: ReadonlyArray<string>, readonly examType: string, readonly examLabel: string, readonly accessionNumber?: string | null, readonly cptCode?: string | null, readonly modifier?: string | null, readonly device?: string | null, readonly billingStatus?: Types.EpocusBillingState | null, readonly missingItems: ReadonlyArray<Types.EpocusBillingMissingItem>, readonly amendedAfterExportAt?: string | null, readonly holdReason?: Types.EpocusBillingHoldReason | null, readonly alreadySent: boolean, readonly renderingProvider: { readonly __typename?: 'EpocusRenderingProvider', readonly name?: string | null, readonly npi?: string | null }, readonly feeEstimate?: { readonly __typename?: 'EpocusStudyFeeEstimate', readonly amountCents?: number | null, readonly needsProgramPostalCode: boolean, readonly unestimatedLineCount: number } | null }>, readonly feeTotals: { readonly __typename?: 'EpocusBillingFeeTotals', readonly readyToBillCents?: number | null, readonly incompleteCents?: number | null, readonly needsProgramPostalCode: boolean, readonly unestimatedLineCount: number } } };

export type EpocusBillingReportQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
  examId: Types.Scalars['ID'];
}>;


export type EpocusBillingReportQuery = { readonly __typename?: 'Query', readonly epocusBillingReport: { readonly __typename?: 'EpocusBillingReport', readonly encounterId: string, readonly examId: string, readonly patientName?: string | null, readonly identifiers: ReadonlyArray<string>, readonly dateOfService?: string | null, readonly examLabel: string, readonly device?: string | null, readonly clinicalIndication?: string | null, readonly findings?: string | null, readonly interpretation?: string | null, readonly billingStatus?: Types.EpocusBillingState | null, readonly missingItems: ReadonlyArray<Types.EpocusBillingMissingItem>, readonly renderingProvider: { readonly __typename?: 'EpocusRenderingProvider', readonly name?: string | null, readonly npi?: string | null }, readonly images: ReadonlyArray<{ readonly __typename?: 'EpocusBillingReportImage', readonly imagingInstanceId: string, readonly previewUrl?: string | null, readonly thumbnailUrl?: string | null }>, readonly procedures: ReadonlyArray<{ readonly __typename?: 'EpocusBillingReportProcedure', readonly cpt: string, readonly modifier?: string | null, readonly units?: number | null, readonly description?: string | null, readonly clinicianConfirmed: boolean }>, readonly signature: { readonly __typename?: 'EpocusBillingReportSignature', readonly signedByName?: string | null, readonly signedById?: string | null, readonly signedAt?: string | null, readonly auditLogged: boolean } } };

export const EpocusBillingDayRowFieldsFragmentDoc = gql`
    fragment EpocusBillingDayRowFields on EpocusBillingDayRow {
  encounterId
  examId
  billingId
  patientName
  identifiers
  examType
  examLabel
  accessionNumber
  cptCode
  modifier
  renderingProvider {
    name
    npi
  }
  device
  billingStatus
  missingItems
  amendedAfterExportAt
  holdReason
  alreadySent
  feeEstimate {
    amountCents
    needsProgramPostalCode
    unestimatedLineCount
  }
}
    `;
export const EpocusBillingDayDocument = gql`
    query EpocusBillingDay($programId: ID!, $serviceDate: DateTime!) {
  epocusBillingDay(programId: $programId, serviceDate: $serviceDate) {
    programId
    serviceDate
    billable {
      ...EpocusBillingDayRowFields
    }
    heldBack {
      ...EpocusBillingDayRowFields
    }
    feeTotals {
      readyToBillCents
      incompleteCents
      needsProgramPostalCode
      unestimatedLineCount
    }
  }
}
    ${EpocusBillingDayRowFieldsFragmentDoc}`;

/**
 * __useEpocusBillingDayQuery__
 *
 * To run a query within a React component, call `useEpocusBillingDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusBillingDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusBillingDayQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      serviceDate: // value for 'serviceDate'
 *   },
 * });
 */
export function useEpocusBillingDayQuery(baseOptions: Apollo.QueryHookOptions<EpocusBillingDayQuery, EpocusBillingDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusBillingDayQuery, EpocusBillingDayQueryVariables>(EpocusBillingDayDocument, options);
      }
export function useEpocusBillingDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusBillingDayQuery, EpocusBillingDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusBillingDayQuery, EpocusBillingDayQueryVariables>(EpocusBillingDayDocument, options);
        }
export type EpocusBillingDayQueryHookResult = ReturnType<typeof useEpocusBillingDayQuery>;
export type EpocusBillingDayLazyQueryHookResult = ReturnType<typeof useEpocusBillingDayLazyQuery>;
export type EpocusBillingDayQueryResult = Apollo.QueryResult<EpocusBillingDayQuery, EpocusBillingDayQueryVariables>;
export const EpocusBillingReportDocument = gql`
    query EpocusBillingReport($programId: ID!, $examId: ID!) {
  epocusBillingReport(programId: $programId, examId: $examId) {
    encounterId
    examId
    patientName
    identifiers
    dateOfService
    examLabel
    renderingProvider {
      name
      npi
    }
    device
    clinicalIndication
    findings
    interpretation
    images {
      imagingInstanceId
      previewUrl
      thumbnailUrl
    }
    procedures {
      cpt
      modifier
      units
      description
      clinicianConfirmed
    }
    signature {
      signedByName
      signedById
      signedAt
      auditLogged
    }
    billingStatus
    missingItems
  }
}
    `;

/**
 * __useEpocusBillingReportQuery__
 *
 * To run a query within a React component, call `useEpocusBillingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusBillingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusBillingReportQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      examId: // value for 'examId'
 *   },
 * });
 */
export function useEpocusBillingReportQuery(baseOptions: Apollo.QueryHookOptions<EpocusBillingReportQuery, EpocusBillingReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusBillingReportQuery, EpocusBillingReportQueryVariables>(EpocusBillingReportDocument, options);
      }
export function useEpocusBillingReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusBillingReportQuery, EpocusBillingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusBillingReportQuery, EpocusBillingReportQueryVariables>(EpocusBillingReportDocument, options);
        }
export type EpocusBillingReportQueryHookResult = ReturnType<typeof useEpocusBillingReportQuery>;
export type EpocusBillingReportLazyQueryHookResult = ReturnType<typeof useEpocusBillingReportLazyQuery>;
export type EpocusBillingReportQueryResult = Apollo.QueryResult<EpocusBillingReportQuery, EpocusBillingReportQueryVariables>;